import { UserData } from "../interfaces/UserData"

export default function setAuthRoutes(userData: UserData){
    return userData.rotas.map(rota => rota)
}